// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5aa6dd3c","732":"8fc8048b"}[chunkId] + ".chunk.js";
};